/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EducationCertificateType
 */
export interface EducationCertificateType {
    /**
     * 
     * @type {number}
     * @memberof EducationCertificateType
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof EducationCertificateType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EducationCertificateType
     */
    nameJa: string;
    /**
     * 
     * @type {string}
     * @memberof EducationCertificateType
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationCertificateType
     */
    noteJa?: string;
    /**
     * 
     * @type {number}
     * @memberof EducationCertificateType
     */
    displayOrder: number;
}

export function EducationCertificateTypeFromJSON(json: any): EducationCertificateType {
    return EducationCertificateTypeFromJSONTyped(json, false);
}

export function EducationCertificateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EducationCertificateType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'nameJa': json['nameJa'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'noteJa': !exists(json, 'noteJa') ? undefined : json['noteJa'],
        'displayOrder': json['displayOrder'],
    };
}

export function EducationCertificateTypeToJSON(value?: EducationCertificateType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'nameJa': value.nameJa,
        'note': value.note,
        'noteJa': value.noteJa,
        'displayOrder': value.displayOrder,
    };
}


